import React from 'react';
import { translate } from '../../Services/translation';
import { useTypedSelector } from '../../Hooks/useTypedSelector';

const ProductsTotalCount = ({}) => {
  const { totalProductsCount } = useTypedSelector(
    (state) => state.productListing
  );
  return (
    <div className="text-sm uppercase text-gray-500">
      {totalProductsCount} {translate('general.products').toLowerCase()}
    </div>
  );
};

export default ProductsTotalCount;
